const AnalyticsEvents = {
  UserEnrolled: 'User Enrolled',
  DemoSourceClicked: 'Demo Source Clicked',
  DemoLinkClicked: 'Demo Link Clicked',
  AppCreated: 'App Created',
  AppDeleted: 'App Deleted',
  AppUpdated: 'App Updated',
  AppKeyCopied: 'App Key Copied',
  AppSecretCopied: 'App Secret Copied',
  ClientAccessTokenCopied: 'Client Access Token Copied',
  PaymentAdded: 'Payment Added',
  PaymentDeleted: 'Payment Deleted',
  PaymentSetAsDefault: 'Payment Set As Default',
  SolutionSelected: 'Solution Selected',
};

export default AnalyticsEvents;
